import type { IconData } from '@stacksjs/iconify-core'

export const eyedropper: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M19.409 431.289v41.468a24.124 24.124 0 0 0 24.1 24.1h33.368a149.45 149.45 0 0 0 106.373-44.065l200.716-200.717l55.846 56.069l22.671-22.582l-55.889-56.114l1.287-1.288l-.021-.02l63.287-63.287a84.853 84.853 0 0 0 0-120l-4-4a84.85 84.85 0 0 0-120 0l-64.326 64.326L230.947 53.1l-22.672 22.58L260.387 128L63.471 324.916a149.45 149.45 0 0 0-44.062 106.373M369.774 63.48a52.854 52.854 0 0 1 74.747 0l4 4a52.913 52.913 0 0 1 0 74.745L387.147 203.6L308.4 124.853Zm-85.72 86.107l78.573 78.573l-69.176 69.176v-.483H136.788ZM104.788 328.853h157.147L160.623 430.165a117.66 117.66 0 0 1-83.746 34.688H51.409v-33.564A117.66 117.66 0 0 1 86.1 347.543Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default eyedropper
